import React from 'react';
import newWindowIcon from 'assets/images/backoffice/online-store/new-window.svg';
import learnMoreShopImage from 'assets/images/backoffice/online-store/learn-more-shop.png';
import styles from './LearnMore.css';

class LearnMore extends React.Component {
  render() {
    const { url, description } = this.props;
    return (
      <div className={styles['learn-more-container']}>
        <div className={styles['learn-more']}>
          <img src={learnMoreShopImage} />
          <div>
            <div>{description}</div>
            <div>
              <a href={url} target="_blank">
                Learn more <img src={newWindowIcon} />
              </a>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default LearnMore;
